<template>
    <p>{{ $t('signal_viewer.modals.symmetrical_components_modal.titles.choose_signal_for_calculating') }}</p>
    <div class="d-flex gap-2">
        <div>
            <label>v<sub>A</sub></label>
            <DxSelectBox :items="signalDataSource" :value="0" displayExpr="name" valueExpr="index"
                @selectionChanged="firstSignalChanged"></DxSelectBox>
        </div>
        <div>
            <label>
                v<sub>B</sub>
            </label>
            <DxSelectBox :items="signalDataSource" :value="signals.length > 2 ? 1 : 0" displayExpr="name"
                valueExpr="index" @selectionChanged="secondSignalChanged"></DxSelectBox>
        </div>
        <div>
            <label>
                v<sub>C</sub>
            </label>
            <DxSelectBox :items="signalDataSource" :value="signals.length > 2 ? 2 : 0" displayExpr="name"
                valueExpr="index" @selectionChanged="thirdSignalChanged"></DxSelectBox>
        </div>
    </div>
    <p class="mt-4">{{
        $t('signal_viewer.modals.symmetrical_components_modal.titles.choose_calculated_symmetrical_components') }}</p>
    <div class="d-flex gap-3 mb-2">
        <div>V<sub>1</sub></div>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.absolute_value')"
            v-model:value="result.components1.absoluteValue"></DxCheckBox>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.phase')"
            v-model:value="result.components1.phase"></DxCheckBox>
    </div>
    <div class="d-flex gap-3 mb-2">
        <div>V<sub>2</sub></div>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.absolute_value')"
            v-model:value="result.components2.absoluteValue"></DxCheckBox>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.phase')"
            v-model:value="result.components2.phase"></DxCheckBox>
    </div>

    <div class="d-flex gap-3 mb-2">
        <div>V<sub>0</sub></div>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.absolute_value')"
            v-model:value="result.components0.absoluteValue"></DxCheckBox>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.phase')"
            v-model:value="result.components0.phase"></DxCheckBox>
        <DxCheckBox :text="$t('signal_viewer.modals.symmetrical_components_modal.dx_check_boxes.instant_values')"
            v-model:value="result.components0.instantValues"></DxCheckBox>
    </div>
</template>

<script setup lang="ts">
import type { SymmetricalDialogResult } from "./osc";
import { DxCheckBox, DxSelectBox } from "devextreme-vue";
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import type { SelectionChangedEvent } from "devextreme/ui/select_box";
import { useModalBuilder } from "@/.shared/helpers/modal-building-helper";


const modal = useModalBuilder();
const props = defineProps<{ signals: string[] }>();
const result: SymmetricalDialogResult = {
    firstSignal: null,
    secondSignal: null,
    thirdSignal: null,
    components0: { absoluteValue: true, phase: false, instantValues: false },
    components1: { absoluteValue: true, phase: false },
    components2: { absoluteValue: true, phase: false },
    result: "cancel"
};

const signalDataSource = computed(() => {
    return props.signals.map((s, idx) => ({ name: s, index: idx }));
})

onMounted(() => {
    modal.setContext(getCurrentInstance()!);
    const { okButton, cancelButton } = modal.standardButtons.addOkCancel();

    okButton.update(b => {
        b.onClick = () => {
            result.result = "ok";
            modal.close(result);
        };
    });

    cancelButton.update(b => {
        b.onClick = () => {
            result.result = "cancel";
            modal.close(result);
        }
    });

});
function firstSignalChanged(e: SelectionChangedEvent) {
    result.firstSignal = e.selectedItem.index;
}

function secondSignalChanged(e: SelectionChangedEvent) {
    result.secondSignal = e.selectedItem.index;
}

function thirdSignalChanged(e: SelectionChangedEvent) {
    result.thirdSignal = e.selectedItem.index;
}


</script>